import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {ChangeDetectionStrategy, Component, Inject} from "@angular/core";
import {MAT_DIALOG_DATA, MatDialog, MatDialogActions, MatDialogClose, MatDialogConfig, MatDialogContent, MatDialogRef, MatDialogTitle} from "@angular/material/dialog";
import {MatButton} from "@angular/material/button";
import {i18n, Oversettelser} from "felles-ng2/tjenester/i18n/Oversettelser";
import {kombiner} from "felles-ng2/støttefunksjoner/objekter";
import {StandardValideringsfeilPipe} from "felles-ng2/pipes/StandardValideringsfeilPipe";

const debug = initDebugger('BekreftelseDialogKomponent');


/** Viser bekreftelsesdialog, brukes via {@link Bekreftelsesdialog}. */
@Component({
    selector: 'bekreftelse-dialog',
    templateUrl: 'bekreftelse-dialog.html',
    styleUrl: 'bekreftelse-dialog.scss',
    imports: [
        MatDialogActions,
        MatDialogTitle,
        MatDialogContent,
        MatDialogClose,
        MatButton
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BekreftelseDialogKomponent {

    static visInfo(dialog: MatDialog, parametre: DialogParametre): MatDialogRef<BekreftelseDialogKomponent, boolean> {
        return dialog.open(BekreftelseDialogKomponent, matDialogKonfig(parametre, DialogStil.info));
    }

    static visAdvarsel(dialog: MatDialog, parametre: DialogParametre): MatDialogRef<BekreftelseDialogKomponent, boolean> {
        return dialog.open(BekreftelseDialogKomponent, matDialogKonfig(parametre, DialogStil.advarsel));
    }

    static visFare(dialog: MatDialog, parametre: DialogParametre): MatDialogRef<BekreftelseDialogKomponent, boolean> {
        return dialog.open(BekreftelseDialogKomponent, matDialogKonfig(parametre, DialogStil.fare));
    }

    parametre: DialogParametreOgStil;

    constructor(private oversettelser: Oversettelser, @Inject(MAT_DIALOG_DATA) parametre: DialogParametreOgStil) {
        this.parametre = kombiner(this.standardVerdier(), parametre);
    }

    //private hjelpemetoder

    private standardVerdier(): Partial<DialogParametre> {
        return {
            okKnapp: this.oversettelser.oversett(i18n('Ok')),
            avbrytKnapp: this.oversettelser.oversett(i18n('Avbryt')),
            droppAvbrytKnapp: false
        };
    }
}

function matDialogKonfig(parametre: DialogParametre, dialogStil: DialogStil): MatDialogConfig<DialogParametreOgStil> {
    return {
        data: {...parametre, dialogStil},
        disableClose: true,
        ariaLabelledBy: 'bekreftelses-dialog-tittel',
        panelClass: `bekreftelseDialogPanel-${dialogStil}`,
        minHeight: 200,
        width: '400px'
    };
}

type DialogParametreOgStil = DialogParametre & { dialogStil: DialogStil };

export interface DialogParametre {
    tittel: string;
    innhold: string;
    okKnapp?: string;
    avbrytKnapp?: string;
    droppAvbrytKnapp?:boolean;
}

export enum DialogStil {
    info = 'info', advarsel = 'advarsel', fare = 'fare'
}
